/* WJW59B.3 — mobile-only placement of native PDP badges and guarantee.
   Place Bestseller + unchanged purchase proof immediately ABOVE the title.
   Preserve original nodes/data; reverse DOM moves when leaving mobile. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width:749px)');
  var saved = new Map();

  function remember(node) {
    if (!node || saved.has(node) || !node.parentNode) return;
    var marker = document.createComment('WJW59B3 original placement');
    node.parentNode.insertBefore(marker, node);
    saved.set(node, marker);
  }
  function restore(node) {
    var marker = saved.get(node);
    if (marker && marker.parentNode) {
      marker.parentNode.insertBefore(node, marker);
      marker.remove();
    }
    saved.delete(node);
  }
  function apply() {
    document.querySelectorAll('.wjw59b-mobile-pdp').forEach(function (pdp) {
      var title = pdp.querySelector('.product-title-container');
      if (!title) return;
      var heading = title.querySelector('.product-title');
      var guarantee = pdp.querySelector('.wjw59b-shared-guarantee');
      var bestseller = pdp.querySelector('#best-seller');
      var proof = pdp.querySelector('.purchase-proof');
      var reorder = pdp.querySelector('#reorder:has(.reorder-btn)');
      var row = pdp.querySelector('.wjw59b2-badge-row');

      if (!mq.matches) {
        restore(proof);
        restore(bestseller);
        restore(guarantee);
        restore(reorder);
        if (row && !row.children.length) row.remove();
        return;
      }

      if (guarantee && !title.contains(guarantee)) {
        remember(guarantee);
        var stars = title.querySelector('.jdgm-preview-badge-mobile');
        var anchor = stars || heading;
        if (anchor) anchor.insertAdjacentElement('afterend', guarantee);
      }

      /* Reuse the original tag-gated reorder button as a secondary pill after
         the title/ratings, before guarantee. Preserve its existing text. */
      if (reorder && heading && !title.contains(reorder)) {
        remember(reorder);
        var starsForReorder = title.querySelector('.jdgm-preview-badge-mobile');
        var after = starsForReorder || heading;
        after.insertAdjacentElement('afterend', reorder);
      }

      /* WJW stabilization: purchase proof must not depend on the presence of
         a Bestseller tag. Move the existing, product-specific node unchanged;
         do not calculate, duplicate, or fabricate counts. */
      if (heading && proof) {
        if (bestseller) remember(bestseller);
        remember(proof);
        if (!row) {
          row = document.createElement('div');
          row.className = 'wjw59b2-badge-row';
        }
        /* Anchor both optional badges immediately above the product title. */
        if (row.parentNode !== heading.parentNode || row.nextElementSibling !== heading) {
          heading.parentNode.insertBefore(row, heading);
        }
        if (bestseller) row.appendChild(bestseller);
        row.appendChild(proof);
      } else if (heading && bestseller) {
        /* Preserve the existing Bestseller-only presentation unchanged. */
        remember(bestseller);
        if (bestseller.parentNode !== heading.parentNode || bestseller.nextElementSibling !== heading) {
          heading.parentNode.insertBefore(bestseller, heading);
        }
      } else if (row && !row.children.length) {
        row.remove();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once:true});
  else apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
})();
